const SubHeaderDirective = function () {
    return {
        restrict: 'E',
        transclude: true,
        replace: true,
        template: '<h5 class="light green-text"><ng-transclude></ng-transclude></h5>'
    }
};

export { SubHeaderDirective };